// src/components/ui/NotificationBadge.js
import { BellRing } from "lucide-react";
import React from "react";

const NotificationBadge = ({ count, onClick }) => {
  return (
    <div style={{ position: "relative", cursor: "pointer" }} onClick={onClick}>
      <BellRing className="h-4 w-4" />
      {count > 0 && (
        <span
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            backgroundColor: "red",
            color: "white",
            borderRadius: "50%",
            padding: "2px 6px",
            fontSize: "12px",
            fontWeight: "bold",
            minWidth: "18px",
            textAlign: "center",
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
};

export default NotificationBadge;
